import { useAuth } from "./contexts/AuthContext";
import { Login } from "./components/Login";
import { Dashboard } from "./components/Dashboard";
import { Toaster } from "react-hot-toast";
import "./index.css";

export function App() {
  const { isAuthenticated, isLoading, login, logout } = useAuth();

  if (isLoading) {
    return (
      <>
        <Toaster position="top-center" />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-lg">Loading...</div>
        </div>
      </>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <Toaster position="top-center" />
        <Login onLogin={login} />
      </>
    );
  }

  return (
    <>
      <Toaster position="top-center" />
      <Dashboard onLogout={logout} />
    </>
  );
}

export default App;
